/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
import isMobile from 'ismobilejs';
import { createSlice } from '@reduxjs/toolkit';

const init = {
  width: window.innerWidth > 960 ? 960 : window.innerWidth,
  hight: 0,
  darkMode: window.matchMedia('(prefers-color-scheme: dark)').matches,
  orientation: '',
  isPhone: isMobile.phone,
};

// Slice
const browserUtils = createSlice({
  name: 'browserUtils',
  initialState: init,
  reducers: {
    onResize: (state, action) => {
      if (state.width === action.payload.width) {
        return;
      }
      state.width = action.payload.width < 960 ? action.payload.width : 960;
    },
    onDarkMode: (state, action) => {
      state.darkMode = action.payload.bool;
    },
    onOrientationChange: (state, action) => {
      state.orientation = action.payload.orientation;
    },
  },
});

export default browserUtils.reducer;

// set up listeners
export const onResize = browserUtils.actions.onResize;
export const onDarkMode = browserUtils.actions.onDarkMode;
export const onOrientationChange = browserUtils.actions.onOrientationChange;
